import React, { useState } from 'react';

export function BinSwap(props) {
  let [ loading, setLoading ] = useState(false);

  return (
    <a className="bin-swap"
      title="Swap bins"
      onClick={e => {
        setLoading(true);
        e.preventDefault();
        props.onChange();
      }}>
      <i className={loading ? 'fa fa-spinner fa-spin' : 'fa fa-exchange'}/>
    </a>
  );
}
